import type { FeatureConfigMap } from '@luna/feature-config';

import type { LeasingFeatureConfig } from '../types/LeasingFeatureConfig';
import { leasing as base } from './base';
import { leasing as AT } from './AT';
import { leasing as CZ } from './CZ';
import { leasing as HR } from './HR';
import { leasing as HU } from './HU';
import { leasing as RO } from './RO';
import { leasing as RS } from './RS';
import { leasing as SK } from './SK';

export const featureConfigMap: FeatureConfigMap<LeasingFeatureConfig> = {
    base,
    AT: AT as LeasingFeatureConfig,
    CZ: CZ as LeasingFeatureConfig,
    HR: HR as LeasingFeatureConfig,
    HU: HU as LeasingFeatureConfig,
    RO: RO as LeasingFeatureConfig,
    RS: RS as LeasingFeatureConfig,
    SK: SK as LeasingFeatureConfig,
};
